import { Col, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useParams } from "react-router-dom";

const NavLink = ({
  to,
  label,
  selected,
}: {
  to: string;
  label: string;
  selected: boolean;
}) => (
  <Link to={to} className={"nav-link" + (selected ? " active" : "")}>
    {label}
  </Link>
);

export const RelationMutateNavigation = () => {
  const { id } = useParams();

  const { t } = useTranslation("common");

  const { pathname } = useLocation();

  return (
    <Col xs="12">
      <Nav variant="underline">
        <Nav.Item>
          <NavLink
            to={`/relations/edit/${id}`}
            label={t("Edit")}
            selected={`/relations/edit/${id}` == pathname}
          />
        </Nav.Item>
        <Nav.Item>
          <NavLink
            to={`/relations/edit/${id}/customers`}
            label={t("Customers")}
            selected={`/relations/edit/${id}/customers` == pathname}
          />
        </Nav.Item>
        <Nav.Item>
          <NavLink
            to={`/relations/edit/${id}/employees`}
            label={t("Employees")}
            selected={`/relations/edit/${id}/employees` == pathname}
          />
        </Nav.Item>
        <Nav.Item>
          <NavLink
            to={`/relations/edit/${id}/import-licence-plates`}
            label={t("Import")}
            selected={`/relations/edit/${id}/import-licence-plates` == pathname}
          />
        </Nav.Item>
      </Nav>
    </Col>
  );
};
